import React, { useEffect, useState } from 'react'
import HomeLayout from '../../../../Layout/HomeLayout';
import HomeHeader from '../../../../CustomComponents/HomeHeader';
import { GetApiHeadersWithBearer, GetRequest } from '../../../../../network/NetworkUtils';
import {useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { AccountDetailsHeder, addLineBreaks, copyToClipboard, MoreServices, QuickActions, SPENDING } from '../../../../../utils';
import { CHECKING, SAVINGS, GET_DDA_DETAILS, GET_DDA_DOWNLOAD_URL, STATUS_SUCCESS_CODE } from '../../../../../network/URLConstants';
import { appTheme, retrieveData, showKudzuPlusPrompt } from '../../../../../helpers/utils/Utils';
import { width } from '../../../../CustomComponents/DynamicHomeCard/DynamicHomeCardStyles';
import DynamicCard from '../../../../CustomComponents/DynamicHomeCard';
import FooterContent from '../../../../CustomComponents/Footer';
import check_scan from '../../../../../assets/images/check_scan.png';
import { useLocation, useNavigate } from 'react-router-dom';
import downloadArrow from '../../../../../assets/images/download_arrow.png';
import logFirebaseEvents from '../../../../LogFirebaseEvents';
import Cookies from 'js-cookie';
import CustomModalPlus from '../../../../../kudzu_plus/helpers/customModalPlus';
import MemnershipEnrollmentScreens from '../../../../../kudzu_plus/components/membershipEnrollmentScreens';
import CardHeading from '../../../../CustomComponents/CardHeading';
import { useDocumentTitle } from '../../../../../hooks/useDocumentTitle';



const DepositMoney = () => {
    const { t } = useTranslation();
    useDocumentTitle(t('page_title_deposit_funds'));

  const moreService = 'sm:w-[90%] w-full pb-[1.5rem] flex justify-between items-center border-b-[3px] border-[#D1E7DD]';
  const moreserviceText = 'font-[600] text-[#262B3A] lg:text-[16px] md:text-[15px] sm:text-[11px] text-[14px] leading-[16px] font-hanken-grotesk';
  
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [checkingAccountNumber, setCheckingAccountNumber] = useState('*********'); //Account Number
  const [checkingRoutingNumber, setCheckingRoutingNumber] = useState('*********');
  const [savingAccountNumber, setSavingAccountNumber] = useState('*********'); //Account Number
  const [savingRoutingNumber, setSavingRoutingNumber] = useState('*********');
  const cards = useSelector(state => JSON.parse(state.userCards));
  const loggedResponse = useSelector(state => JSON.parse(state.loggedInResponse));
  const accessTokenToApi = useSelector(state => state.accessToken);
  const [accountCopied, setAccountCopied] = useState(false);
  const [routingCopied, setRoutingCopied] = useState(false);
  const [loading, setLoading] = useState(false)
  const cardDetails = useSelector(state => state.selectedCardDetails);
  const kudzuPlusTrue = useSelector(state => state.kudzuPlusTrue);
  const isShowKudzuPlusPrompt = showKudzuPlusPrompt(loggedResponse);


  const [showModel, setShowModel] = useState(false);
  const HighlightMsgStyles = "font-serif-pro modal-title lg:text-[32px] md:text-[28px] sm:text-[23px] text-[27px] lg:leading-[38px] md:leading-[32px] sm:leading-[30px] leading-[31px] font-normal text-[var(--modal-text-highlight)]  cursor-pointer pointer-events-none";
  const HeaderMsgStyles = "font-serif-pro modal-title lg:text-[32px] md:text-[28px] sm:text-[23px] text-[27px] lg:leading-[38px] md:leading-[32px] sm:leading-[30px] leading-[31px] font-normal cursor-pointer pointer-events-none";
  const SubHeaderMsgStyles = "font-hanken-grotesk modal-title lg:text-[14px] md:text-[13px] sm:text-[11px] text-[12px] font-normal cursor-pointer pointer-events-none";
  const [modelImage, setModelImage] = useState('')
  const [highlightMsg, setHighlightMsg] = useState('')
  const [headerMsg, setheaderMsg] = useState('')
  const [subHeaderMsg, setSubHeaderMsg] = useState('')
  const [btn1Exists, setBtn1Exists] = useState(false)
  const [btn2Exists, setBtn2Exists] = useState(false)
  const [btn1Text, setBtn1Text] = useState(false)
  const [btn2Text, setBtn2Text] = useState('')
  const [btn1TypeAcpt, setBtn1TypeAcpt] = useState(false)
  const [footerMsg, setFooterMsg] = useState('');
  const [toNavigate, setToNavigate] = useState('');
  const [isBorderNone, setisBorderNone] = useState(true);
  const [showErrorImg, setshowErrorImg] = useState(false);

  const [showPlusModal, setShowPlusModal] = useState(false);
  const [showCarouselScreenShow, setShowCarouselScreensShow] = useState(false);

  const [carousel, setCarousel] = useState('');
  const [btn1BgColor, setBtn1BgColor] = useState("");
  const [summaryParagraph, setSummaryParagraph] = useState('');
  const [opacityValueLow, setOpacityValueLow] = useState(false);
  const [comparisonScreen, setComparisonScreen] = useState('');
  const [fullWidth, setFullWidth] = useState(false);
  const [footerButtonEnable, setFooterButtonEnable] = useState(false);
  const [gradientButton, setGradientButton] = useState(false);
  const [largeImage, setLargeImage] = useState(false);

  const currentpath = useLocation();
  const appThemeData = appTheme(kudzuPlusTrue)

  const summaryParagraphStyles = "font-hanken-grotesk modal-title text-[#94C3E8] lg:text-[13px] md:text-[10px] sm:text-[6px] text-[8px] font-[200] cursor-pointer pointer-events-none";
  const HeaderMsgStylesForPlus = "font-serif-pro modal-title text-white lg:text-[32px] md:text-[28px] sm:text-[23px] text-[27px] lg:leading-[38px] md:leading-[32px] sm:leading-[30px] leading-[31px] font-[400] cursor-pointer pointer-events-none";
  const SubHeaderMsgPlusStyles = "font-hanken-grotesk mt-[14px] modal-title md:text-[18px] sm:text-[14px] text-[16px] sm:leading-[27px] lg:leading-[30px] md:leading-[30px] leading-[30px] font-normal cursor-pointer pointer-events-none text-white";



  useEffect(() => {
    if (cards != undefined || cards != null) {
      
      cards.map((item) => {
        const { AccountTypeName, CardKey } = item;
        getAccountNumberDetails(AccountTypeName, CardKey);
        return null; // Return null from the map to avoid returning a new array
      });
    }
  
  }, []);


  const getAccountNumberDetails = async (cardType, cardkey) => {
    if (cardkey == undefined || cardkey == null) {
      return
    }
    setLoading(true)
    let url = GET_DDA_DETAILS + cardkey;
    const deviceId = await retrieveData('updatedDeviceId');
    const headers = await GetApiHeadersWithBearer(deviceId, accessTokenToApi);
    var response = await GetRequest(url, headers)
    setTimeout(() => {
      setLoading(false)
    }, 500);
    var responseObj = JSON.parse(response);
    if (responseObj.ResponseCode == STATUS_SUCCESS_CODE) {
      if (responseObj.Response != undefined) {
        if (cardType == CHECKING || SPENDING) {
          setCheckingAccountNumber(responseObj.Response.ExternalSVAID != undefined ? responseObj.Response.ExternalSVAID : '--');
          setCheckingRoutingNumber(responseObj.Response.RoutingNumber != undefined ? responseObj.Response.RoutingNumber : '--')
        } else {
          setSavingAccountNumber(responseObj.Response.ExternalSVAID != undefined ? responseObj.Response.ExternalSVAID : '--');
          setSavingRoutingNumber(responseObj.Response.RoutingNumber != undefined ? responseObj.Response.RoutingNumber : '--')
        }

      }
    } else {
      var arrMessages = responseObj.Messages;
      var message = arrMessages[0];
      var displayText = message.DisplayText;
    }
  }


  const accountNumberCopiedClicked = () => {
    copyToClipboard(checkingAccountNumber, setAccountCopied(true))
    setAccountCopied(true);
    setTimeout(() => {
      setAccountCopied(false);
    }, 2000);

  }
  const routingNumberCopiedClicked = () => {
    copyToClipboard(checkingRoutingNumber, setRoutingCopied(true))
    setRoutingCopied(true);
    setTimeout(() => {
      setRoutingCopied(false);
    }, 2000);
  }

  ///Quick Actions

  const QuickActionsButtons = [
    { name: `${t('Load Cash')}`, actionType: "", path: "/AccountServices/Spending/AddFunds/AddCash" },
    { name: "Manage Direct Deposit ", actionType: "", path: "/AccountServices/Spending/AddFunds/ManageDirectDeposit" }

  ]


  const depositCashClicked = () => {
    debugger
    setShowCarouselScreensShow(false)
    if (!kudzuPlusTrue) {
      if (isShowKudzuPlusPrompt === true) {
        const carouselHideForSetupDdVal = `carouselHideForSetupDd${cards[0].CardKey}`;
        const modalShown = Cookies.get(carouselHideForSetupDdVal);
          if(modalShown === null || modalShown === undefined || modalShown == "false"){
              const currentPath = { currentPathFromStore: currentpath.pathname };
              dispatch({ type: 'CURRENT_LOCATION', payload: currentPath });
              showAlertModalPlus(true, t(""), addLineBreaks(t("get_acces_to_ach_funds_up_to_2_days_with_kudzu+")), addLineBreaks(t('learn_and_grow_with_a_free_3_month_kudzu_upgrade')), true, true, t('Learn_More'), t('No_Thanks'), true, require('.././../../../../assets/kudzu-plus-images/setupDirectDepBanner.png'), "", true, "#262B3A", addLineBreaks(t('4.95_per_month_after_first_3_month_after_charged_automatically_cancel_anytime')), true, '', false, false, true, true);
          }
          else{
            logFirebaseEvents(cardDetails.AccountTypeName+"_"+"add_cash", cardDetails.AccountTypeName+"_"+"setup_direct_deposit_clicked", "setup_direct_deposit_clicked","", "");
            navigate('/AccountServices/Spending/AddFunds/ManageDirectDeposit');
          }
      }
        else{
          logFirebaseEvents(cardDetails.AccountTypeName+"_"+"add_cash", cardDetails.AccountTypeName+"_"+"setup_direct_deposit_clicked", "setup_direct_deposit_clicked","", "");
          navigate('/AccountServices/Spending/AddFunds/ManageDirectDeposit');
        }
     }else{
      logFirebaseEvents(cardDetails.AccountTypeName+"_"+"add_cash", cardDetails.AccountTypeName+"_"+"setup_direct_deposit_clicked", "setup_direct_deposit_clicked","", "");
      navigate('/AccountServices/Spending/AddFunds/ManageDirectDeposit');
    }
   
  }
  const showAlertModalPlus = (showPlusModal, highlightMsg, headerMsg, subHeaderMsg, btn1Exists, btn2Exists, btn1Text, btn2Text, btn1TypeAcpt, modelImage, carousel, isBorderNone, btn1BgColor, summaryParagraph, opacityValue, comparisonScreen, fullWidth, footerButtonEnable, gradientButton, largeImage) => {
    setShowPlusModal(showPlusModal)
    setHighlightMsg(highlightMsg)
    setheaderMsg(headerMsg)
    setSubHeaderMsg(subHeaderMsg)
    setBtn1Exists(btn1Exists)
    setBtn2Exists(btn2Exists)
    setBtn1Text(btn1Text)
    setBtn2Text(btn2Text)
    setBtn1TypeAcpt(btn1TypeAcpt)
    setModelImage(modelImage)
    setBtn1Exists(btn1Exists)
    setBtn1Text(btn1Text)
    setCarousel(carousel)
    setisBorderNone(isBorderNone)
    setBtn1BgColor(btn1BgColor)
    setSummaryParagraph(summaryParagraph)
    setOpacityValueLow(opacityValue)
    setComparisonScreen(comparisonScreen)
    setFullWidth(fullWidth)
    setFooterButtonEnable(footerButtonEnable)
    setGradientButton(gradientButton)// gradient button for popup
    setLargeImage(largeImage)
}


  //footer
  const footerContent = () => {
    return (
      < FooterContent  
        type={t("set_up_dd_btn")}
        highlightText={t("set_up_dd_text")}
        subHeaderText={t("paper_work")} image={appThemeData.downArrowIconAddfunds}
        isSpace={true} isSubheadingwidth={true}
        buttonEnabled={true} buttonText={t("set_up_dd_btn")}
        footerBtnAction={depositCashClicked} />
    )

  }


  const closeModelPlus = () => {
    setShowPlusModal(false);
    logFirebaseEvents(cardDetails.AccountTypeName+"_"+"add_cash", cardDetails.AccountTypeName+"_"+"setup_direct_deposit_clicked", "setup_direct_deposit_clicked","", "");
    navigate('/AccountServices/Spending/AddFunds/ManageDirectDeposit');
  }

  const onAcptBtnClickPlusModal = () => {
    setShowPlusModal(false)
    setShowCarouselScreensShow((prev) => !prev);
    // navigate("/memnershipEnrollmentScreens")
    const data = { kudzuFlowFrom: t("setup_direct_Deposit") };
    dispatch({ type: 'KUDZU_PLUS_FROM', payload: data });
  }

  const onCancelBtnClickPlusModal = () => {
    const carouselHideForSetupDdVal = `carouselHideForSetupDd${cards[0].CardKey}`;
    Cookies.set(carouselHideForSetupDdVal, 'true', { expires: 1825 });
    setShowPlusModal(false)
    logFirebaseEvents(cardDetails.AccountTypeName+"_"+"add_cash", cardDetails.AccountTypeName+"_"+"setup_direct_deposit_clicked", "setup_direct_deposit_clicked","", "");
    navigate('/AccountServices/Spending/AddFunds/ManageDirectDeposit');
  }

  return (
    <HomeLayout>
      <HomeHeader heading="Hello, Sam. You’ve spent $405 in the last week." 
      isHeaderCaption={false} 
      selectedIndex={1} />
      {showCarouselScreenShow &&
        <MemnershipEnrollmentScreens />}
      <div className='flex flex-col lg:w-[860px] md:w-[860px] sm:w-[464px] w-[100%] 
      animate__animated animate__fadeInRight  '>

        <DynamicCard
          header={true}
          footer={false}
          CardRadius={true}
          HeaderRadius={true}
          isWhite={appThemeData.isWhiteBgForCard}
          isDarkForKudzu={appThemeData.isDarkBgForCard}
          cardWidth={width.homeCard}
          backgroundColor={'--cardHeading-bg'} 
          HeaderContent={
            <>
                <CardHeading heading={t("menu_deposit_money")} />
            </>
        }
        >
          {/* <div className=" lg:my-[2rem] md:my-[1.5rem] my-[1.5rem] font-[500] 
         lg:text-[26px] md:text-[22px] 
         sm:text-[20px] text-[20px]
            leading-[36px] font-hanken-grotesk sm:mx-0 mx-4">
            {t("menu_deposit_money")}
          </div> */}
          <AccountDetailsHeder
            AccountNo={checkingAccountNumber}
            routingNo={checkingRoutingNumber}
            accountCopiedProps={accountCopied}
            routingCopiedProps={routingCopied}
            handleCopyClick={accountNumberCopiedClicked}
            handleCopyRoutingNumberClick={routingNumberCopiedClicked}
            contentBetween={true}
            topBorder={appThemeData.borderTopForAccServices}
            bottomBorder={true}
            isCopyblack={true}
          />

          <QuickActions actionsArray={QuickActionsButtons} />


        </DynamicCard>
        {footerContent()}
       
      </div>
      <CustomModalPlus isOpen={showPlusModal} onClose={closeModelPlus}
                image={modelImage}
                carousel={carousel}
                summaryParagraph={<p className={summaryParagraphStyles}>{summaryParagraph}</p>}
                isBorderNone={isBorderNone}
                highlightMsg={<p className={HeaderMsgStylesForPlus}> {headerMsg}</p>}
                subHeaderMsg={<p className={SubHeaderMsgPlusStyles}>{subHeaderMsg}</p>}
                btn1Exists={btn1Exists}
                btn2Exists={btn2Exists}
                btn1Text={btn1Text}
                btn1BgColor={btn1BgColor}
                btn2Text={btn2Text}
                opacityLow={opacityValueLow}
                defaultCornerRadius={false}
                btn1TypeAcpt={btn1TypeAcpt}
                onAcptBtnClick={onAcptBtnClickPlusModal}
                onCancelBtnClick={onCancelBtnClickPlusModal}
                gradientButton={gradientButton}
                largeImage={largeImage}
            />
    </HomeLayout>
  )
}

export default DepositMoney;